var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
import { bonfireGet } from "../../../theme";
var SortIcon = function (props) {
    var fillColor = bonfireGet("colors", "surface").defaultValue();
    return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 30 30" }),
        React.createElement("g", { id: "Icon/ic_sort", strokeWidth: "0" },
            React.createElement("path", { id: "sort-ascend", fill: fillColor, d: "M15 6 L21 14 L9 14 Z" }),
            React.createElement("path", { id: "sort-descend", fill: fillColor, d: "M15 25 L21 17 L9 17 Z" }))));
};
export default SortIcon;
//# sourceMappingURL=SortIcon.js.map